/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    searchActivity(payload) {
        return HttpService.get(environment.API_SEARCH_ACTIVITY, {
            params: payload,
        });
    },
    getMetaData() {
        return HttpService.get(environment.API_GET_META_DATA);
    },

    getApplication() {
        return HttpService.get(environment.API_GET_APPLICATION);
    },

    searchInquiry(id) {
        return HttpService.get(environment.API_SEARCH_INQUIRY + '/' + id);
    },

    // Activity Tab
    updateMetadataByActivity(payload) {
        return HttpService.put(environment.API_METADATA + '/activity', payload);
    },

    deleteMetadataByActivity(metadataId, activityId) {
        return HttpService.delete(
            environment.API_METADATA +
                '/' +
                metadataId +
                '/activity/' +
                activityId
        );
    },
    deleteMetadata(metadataId) {
        return HttpService.delete(environment.API_METADATA + '/' + metadataId);
    },
    getActivityDetail(businessProcessId, params) {
        return HttpService.get(
            environment.API_DATA_CORRELATION + '/activity/' + businessProcessId,
            {
                params,
            }
        );
    },

    // Contract Tab
    getContractDetail(params) {
        return HttpService.get(environment.API_CONTRACT + '/detail', {
            params,
        });
    },
    getContractBusinessProcess(contractId) {
        return HttpService.get(
            environment.API_DATA_CORRELATION +
                '/contract/business-process/dropdown?contractId=' +
                contractId
        );
    },
    addContractBusinessProcess(payload) {
        return HttpService.post(
            environment.API_DATA_CORRELATION + '/contract/business-process',
            payload
        );
    },
    getContractActivity(params) {
        return HttpService.get(
            environment.API_DATA_CORRELATION + '/contract/activity/dropdown',
            {
                params,
            }
        );
    },
    deleteBusinessProcess(contractId, businessProcessId) {
        return HttpService.delete(
            environment.API_DATA_CORRELATION +
                `/contract/${contractId}/business-process/${businessProcessId}`
        );
    },
    addContractActivity(payload) {
        return HttpService.post(
            environment.API_DATA_CORRELATION + '/contract/activity',
            payload
        );
    },
    deleteContractActivity(contractId, activityId) {
        return HttpService.delete(
            environment.API_DATA_CORRELATION +
                `/contract/${contractId}/activity/${activityId}`
        );
    },
    getContractDropdown() {
        return HttpService.get(environment.API_CONTRACT_DROPDOWN);
    },

    getTypeDropdown() {
        return HttpService.get(environment.API_TYPE_DROPDOWN);
    },

    getPurposeDropdown() {
        return HttpService.get(environment.API_PURPOSE_DROPDOWN);
    },

    searchContract(payload) {
        return HttpService.get(environment.API_CONTRACT_SEARCH, {
            params: payload,
        });
    },

    getConsentDetail(payload) {
        return HttpService.get(environment.API_CONSENT_DETAIL + payload);
    },

    // Application Tab

    getApplications() {
        return HttpService.get(
            environment.API_DATA_CORRELATION + '/application'
        );
    },
    getApplicationById(applicationId) {
        return HttpService.get(
            environment.API_DATA_CORRELATION + '/contract/' + applicationId
        );
    },
    getApplicationContractDropdown() {
        return HttpService.get(environment.API_DATA_CORRELATION + '/contract');
    },
    addApplication(payload) {
        return HttpService.post(
            environment.API_DATA_CORRELATION + '/application',
            payload
        );
    },
    editApplication(payload) {
        return HttpService.put(
            environment.API_DATA_CORRELATION + '/application',
            payload
        );
    },
    addContract(payload) {
        return HttpService.post(
            environment.API_DATA_CORRELATION + '/contract',
            payload
        );
    },
    deleteContract(contractId, applicationId) {
        return HttpService.delete(
            environment.API_DATA_CORRELATION +
                '/contract/' +
                contractId +
                '/application/' +
                applicationId
        );
    },
    deleteApplication(applicationId) {
        return HttpService.delete(
            environment.API_DATA_CORRELATION + '/application/' + applicationId
        );
    },
};
